/**
 * @file Confirm With Password Container.
 */

import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';

import ConfirmWithPasswordModal from '../../components/global/ConfirmWithPasswordModal';
import { accountLogin } from '../../graphql/mutations/account';
import { MeQuery } from '../../graphql/queries/account';

const withUserData = graphql(MeQuery, {
  props: ({ data, loading }) => ({
    user: data.me,
    loading,
  }),
  skip: ({ authenticated }) => !authenticated,
});

const withLoginMutation = graphql(accountLogin, {
  props: ({ mutate }) => ({
    accountLogin: (email, password) =>
      mutate({
        variables: {
          input: { email, password },
        },
      }),
  }),
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  connect(mapStateToProps),
  withUserData,
  withLoginMutation,
)(ConfirmWithPasswordModal);
